export default function LpVideo() {
  return <div />;
}
